<template>
  <a-modal :centered="true" v-model="showModal" :footer="null" @cancel="callDiscard" width="587px" class="mobile-modal-fullscreen create-post-modal" :closable="false" :maskClosable="false">
    <div v-if="currentDisplay === 'add'" :key="postType" class="create-post-comp">
      <div class="d-flex align-items-center mob-shadow">
        <font-awesome-icon size="2x" :icon="['fal', 'times']" class="show-in-mobile font-black mr-3 font20" @click="callDiscard" />
        <h4 class="fw700 font24 gray700 mb-0">
          {{ editing ? `Edit ${postType === "press" ? "press release" : postType}` : onlyQuestion ? "Ask a Question" : `Create ${postType === "press" ? "press release" : postType}` }}
        </h4>
        <!-- <div class="saveBtn ml-auto br6 p1224 font-white font14 fw700 cp show-in-mobile" :style="{ background: getPrimaryColor() }" @click="post">
          <template v-if="posting"> <a-spin size="small" class="mr-2" /> Loading... </template>
          <template v-else> {{ editing ? "Save" : "Post" }} </template>
        </div> -->
        <button
          class="saveBtn ml-auto br6 p1224 font-white font14 fw700 cp show-in-mobile"
          :style="{ background: getPrimaryColor(), border: 'none', opacity: checkDisabled ? 0.5 : 1, cursor: checkDisabled ? 'auto !important' : 'pointer' }"
          @click="post"
          :disabled="checkDisabled"
        >
          <template v-if="posting"> <a-spin size="small" class="mr-2" /> Loading... </template>
          <template v-else> {{ editing ? "Save" : "Post" }} </template>
        </button>
        <font-awesome-icon size="2x" :icon="['fal', 'times']" class="hide-in-mobile font-black ml-auto cp font20" @click="callDiscard" />
      </div>

      <div class="d-flex align-items-center my-4">
        <img v-if="authUser.user.url" class="hw40 rounded-circle" :src="authUser.user.url" />
        <div v-else class="hw40 flex-center-center fw700 font16 text-white rounded-circle ar1" :style="{ background: getAvatarColor(authUser.user.id) }">
          {{ getAuthUserInitials() }}
        </div>
        <div class="d-flex align-items-center flex-wrap">
          <p class="fw700 font14 gray900 ml-2 mb-0 text-capitalize">{{ authUser.user.display_name }}</p>
          <DisplayTags
            :selectedFeeling="selectedFeeling"
            :selectedCategory="selectedCategory"
            :isQuestion="isQuestion"
            :changeScreen="changeScreen"
            :removeQuestionTag="removeQuestionTag"
            :removeFeeling="removeFeeling"
            :selectedCelebration="selectedCelebration"
            :removeCelebration="removeCelebration"
            :postType="postType"
            :removeTag="removeTag"
            :editing="editing"
            :onlyQuestion="onlyQuestion"
          />
        </div>
      </div>

      <NewPostData
        :key="postType"
        :getTextData="getTextData"
        :addingImages="addingImages"
        :handleCancelImage="handleCancelImage"
        :prevText="postDescription"
        :getImageData="getImageData"
        :userName="authUser.user.display_name"
        :changeScreen="changeScreen"
        :imgArray="imagesArray"
        :selectedLinkToParse="selectedLinkToParse"
        :selectLink="selectLink"
        :addLink="addLink"
      />

      <NewPollData v-if="postType === 'poll'" :displayData="displayData" :handleDelete="handleDeleteData" :handleEdit="handleEditData" />

      <NewEventData v-else-if="postType === 'event'" :handleDelete="handleDeleteData" :handleEdit="handleEditData" :displayData="displayData" :user="authUser.user.display_name" />

      <NewJobData v-else-if="postType === 'job'" :handleDelete="handleDeleteData" :handleEdit="handleEditData" :displayData="displayData" />

      <NewPressReleaseData v-else-if="postType === 'press'" :handleDelete="handleDeleteData" :handleEdit="handleEditData" :displayData="displayData" />

      <!-- TAGS -->
      <div class="d-flex flex-wrap mt-4" v-if="selectedTags.length">
        <div class="rounded p-2 bg-gray50 d-flex align-items-center fw700 gray500 font14 mr-2 mb-2" v-for="tag in selectedTags" :key="tag">
          {{ tag }} <font-awesome-icon :icon="['fas', 'trash']" class="cp error300 ml-2" @click="handleDeleteTag(tag)" />
        </div>
      </div>

      <p class="fw700 font16 mb-0 gray500 mt-4">Add to your post</p>

      <DisplayOptions :changeScreen="changeScreen" :optionList="optionList" />

      <div class="d-flex mt-4 hide-in-mobile">
        <div class="bg-gray200 br6 fw700 font14 gray600 cp p1224 ml-auto" @click="callDiscard">Cancel</div>
        <!-- <div class="br6 fw700 font14 text-white cp p1224 ml-3" :style="{ background: getPrimaryColor() }" @click="post">
          <template v-if="posting"> <a-spin size="small" class="mr-2" /> Loading... </template>
          <template v-else> {{ editing ? "Save" : "Post" }} </template>
        </div> -->
        <button
          class="br6 fw700 font14 text-white cp p1224 ml-3"
          :style="{ background: getPrimaryColor(), border: 'none', opacity: checkDisabled ? 0.5 : 1, cursor: checkDisabled ? 'auto !important' : 'pointer' }"
          @click="post"
          :disabled="checkDisabled"
        >
          <template v-if="posting"> <a-spin size="small" class="mr-2" /> Loading... </template>
          <template v-else> {{ editing ? "Save" : "Post" }} </template>
        </button>
      </div>
    </div>

    <FeelingsScreen v-else-if="currentDisplay === 'feelings'" :changeScreen="changeScreen" :selectedFeeling="selectedFeeling" :hide="callDiscard" />
    <CelebrationsScreen v-else-if="currentDisplay === 'celebrations'" :changeScreen="changeScreen" :selectedCelebration="selectedCelebration" :hide="callDiscard" />
    <CategoriesScreen v-else-if="currentDisplay === 'categorys'" :changeScreen="changeScreen" :selectedCategory="selectedCategory" :hide="callDiscard" />
    <MoreOptionsScreen v-else-if="currentDisplay === 'moreOptions'" :changeScreen="changeScreen" :selectedOptions="getSelectedOptions" :disabledOptions="getDisabledOptions" :hide="callDiscard" />
    <TagsScreen v-else-if="currentDisplay === 'tags'" :changeScreen="changeScreen" :prevSelectedTags="selectedTags" :hide="callDiscard" />
    <PollScreen
      v-else-if="currentDisplay === 'poll'"
      :changeScreen="changeScreen"
      :getData="getDisplayData"
      :handleCancelImage="handleCancelImage"
      :pollData="displayData"
      :addingImages="addingImages"
      :hide="callDiscard"
    />
    <AllPicturesScreen v-else-if="currentDisplay === 'pictures'" :getImageData="getImageData" :changeScreen="changeScreen" :ImagesArrayProp="imagesArray" :hide="callDiscard" />
    <LinkPreviewScreen v-else-if="currentDisplay === 'linkpreview'" :changeScreen="changeScreen" :hide="callDiscard" :linksToPreview="allLinksToParse" :selectLink="selectLink" />
    <Discard :discardPost="hide" ref="discardModal" />
  </a-modal>
</template>

<script>
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import { quillEditor } from "vue-quill-editor"
import CustomEmojiPicker from "../home/emojiPicker.vue"
import FeelingsScreen from "../home/createNewPost/Feelings.vue"
import CelebrationsScreen from "../home/createNewPost/Celebrations.vue"
import CategoriesScreen from "../home/createNewPost/Categories.vue"
import TagsScreen from "../home/createNewPost/Tags.vue"
import MoreOptionsScreen from "../home/createNewPost/MoreOptions.vue"
import LinkPreviewScreen from "../home/createNewPost/LinkPreview.vue"
import PollScreen from "../home/createNewPost/Poll.vue"
import NewPostData from "../home/createNewPost/data/Post.vue"
import NewPollData from "../home/createNewPost/data/Poll.vue"
import NewJobData from "../home/createNewPost/data/Job.vue"
import NewPressReleaseData from "../home/createNewPost/data/PressRelease.vue"
import NewEventData from "../home/createNewPost/data/Event.vue"
import DisplayTags from "../home/createNewPost/DisplayTags.vue"
import DisplayOptions from "../home/createNewPost/DisplayOptions.vue"
import AllPicturesScreen from "../home/createNewPost/Pictures.vue"
import Discard from "./activity/Discard.vue"
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faTimes, faEllipsisV as faEllipsisVL } from "@fortawesome/pro-light-svg-icons"
import { faImage, faCommentAltSmile, faQuestionCircle, faTag, faEllipsisV as faEllipsisVS } from "@fortawesome/pro-solid-svg-icons"
import moment from "moment"

library.add(faImage, faTimes, faQuestionCircle, faTag, faCommentAltSmile, faEllipsisVS, faEllipsisVL)
const PostRepository = RepositoryFactory.get("posts")

export default {
  name: "CreateNewPostModal",
  props: {
    getPost: { default: () => {}, type: Function },
    showCongrats: { default: () => {}, type: Function },
    handleOtherModals: { default: () => {}, type: Function },
    questionType: String,
  },
  components: {
    quillEditor,
    CustomEmojiPicker,
    FeelingsScreen,
    CelebrationsScreen,
    CategoriesScreen,
    TagsScreen,
    MoreOptionsScreen,
    LinkPreviewScreen,
    PollScreen,
    NewPostData,
    NewPollData,
    NewJobData,
    NewPressReleaseData,
    NewEventData,
    DisplayTags,
    DisplayOptions,
    AllPicturesScreen,
    Discard,
  },
  data() {
    return {
      onlyQuestion: false,
      posting: false,
      postDescriptionLength: 0,
      backScreen: "add",
      oldPostId: undefined,
      // postType: null,
      postType: "post",
      displayData: {
        img: [],
        title: "",
        subTitle: "",
        description: "",
        choices: [
          { choice_text: "", correct: false },
          { choice_text: "", correct: false },
        ],
        time: "",
        eventType: "",
        location: "",
        reDirectionText: "Go to job",
        reDirectionLink: "",
        tags: [],
        pollDuration: "Forever",
        jType: "",
        wType: "",
      },
      typesOfPollDurations: ["1 day", "3 days", "1 week", "2 weeks", "Forever"],
      editing: false,
      showModal: false,
      postDescription: "",
      selectedFeeling: { name: "" },
      selectedCelebration: "",
      selectedCategory: "",
      selectedTags: [],
      imagesArray: [],
      isQuestion: false,
      addingImages: false,
      currentDisplay: "add",
      optionList: [
        {
          name: "Image/Video",
          disabled: false,
          selected: false,
          icon: "image",
          screen: "image",
          description: "Add Images",
        },
        {
          screen: "feelings",
          name: "Feeling",
          selected: false,
          disabled: false,
          icon: "comment-alt-smile",
          description: "Add Feeling",
        },
        {
          name: "Tags",
          selected: false,
          screen: "tags",
          disabled: false,
          icon: "tag",
          description: "Add Tags",
        },
        {
          name: "Ask",
          selected: false,
          screen: "question",
          disabled: false,
          icon: "question-circle",
          description: "Mark as Question",
        },
        {
          name: "More options",
          screen: "moreOptions",
          disabled: false,
          selected: false,
          icon: "ellipsis-v",
          description: "See more options",
        },
      ],
      message_reciever_id: null,
      isLinkParsed: false,
      allLinksToParse: [],
      selectedLinkToParse: "",
    }
  },
  created() {
    const backButtonRouteGuard = this.$router.beforeEach((to, from, next) => {
      if (this.showModal) {
        next(false)
        this.callDiscard()
      } else {
        next(true)
      }
    })
    this.$once("hook:destroyed", () => {
      backButtonRouteGuard()
    })
  },
  computed: {
    getSelectedOptions() {
      let selectedOpts = []
      selectedOpts = this.optionList.map(o => {
        if (o.selected) {
          return o.screen
        } else {
          return ""
        }
      })
      if (this.selectedCelebration) {
        selectedOpts.push("celebrations")
      }
      switch (this.postType) {
        case "poll":
          selectedOpts.push("poll")
          break
        case "job":
          selectedOpts.push("job")
          break
        case "press":
        case "pressRelease":
          selectedOpts.push("pressRelease")
          break
        case "event":
          selectedOpts.push("event")
          break
      }
      return selectedOpts
    },
    getDisabledOptions() {
      let disOpts = []
      disOpts = this.optionList.map(o => {
        if (o.disabled) {
          return o.screen
        } else {
          return ""
        }
      })
      if (this.postType === "poll") {
        disOpts.push("question", "pressRelease", "event", "job", "image", "feelings")
      }
      if (this.postType === "pressRelease" || this.postType === "press") {
        disOpts.push("question", "poll", "event", "job", "image", "feelings")
      }
      if (this.postType === "job") {
        disOpts.push("question", "pressRelease", "event", "poll", "image", "feelings")
      }
      if (this.postType === "event") {
        disOpts.push("question", "pressRelease", "poll", "job", "image", "feelings")
      }
      if (this.isQuestion || this.imagesArray.length) {
        disOpts.push("poll", "pressRelease", "event", "job")
      }
      if (this.selectedFeeling.name || this.postType !== "post" || this.isQuestion) {
        disOpts.push("celebrations")
      }
      if (this.selectedFeeling.name || this.selectedCelebration) {
        disOpts.push("poll", "question", "pressRelease", "event", "job")
      }
      if (this.editing) {
        disOpts.push("question", "poll", "pressRelease", "event", "job")
      }
      return disOpts
    },
    checkDisabled() {
      if (((this.postType === "post" || this.postType === "question") && !(this.postDescriptionLength || this.imagesArray.length)) || this.postDescriptionLength > 5000) {
        return true
      }
      return false
    },
  },
  methods: {
    // checkDisabled() {
    //   if ((this.postType === "post" || this.postType === "question") && !(this.postDescriptionLength || this.imagesArray.length)) {
    //     return true
    //   }
    //   return false
    // },
    addLink(link, empty = false) {
      if (empty) {
        this.allLinksToParse = []
        return
      }
      if (!this.allLinksToParse.includes(link)) {
        this.allLinksToParse.push(link)
      }
      console.log("this.allLinksToParse:", this.allLinksToParse)
    },
    selectLink(link) {
      this.selectedLinkToParse = link
      console.log("this.selectedLinkToParse:", this.selectedLinkToParse)
    },
    callDiscard() {
      if ((this.postType === "post" || this.postType === "question") && !this.postDescriptionLength) {
        this.hide()
      } else {
        this.$refs.discardModal.show(this.postType)
      }
    },
    removeTag() {
      // for removing POLL JOB EVENT PRESS
      this.postType = "post"
      this.displayData = {
        img: [],
        title: "",
        subTitle: "",
        description: "",
        choices: [
          { choice_text: "", correct: false },
          { choice_text: "", correct: false },
        ],
        time: "",
        eventType: "",
        location: "",
        reDirectionText: "Go to job",
        reDirectionLink: "",
        tags: [],
        pollDuration: "Forever",
        jType: "",
        wType: "",
      }
      this.disableOption("Ask", false)
      this.disableOption("Feeling", false)
      this.disableOption("Image/video", false)
      this.disableOption("More options", false)
    },
    getImageData(v) {
      this.currentDisplay = "add"
      this.imagesArray = v
    },
    handleCancelImage(noImage = false) {
      // console.log("handleCancelImage called")
      // console.log("noImage ->", noImage)
      this.addingImages = !noImage
      this.imagesArray = []
      this.displayData.img = []
      this.deSelectOption("Image/video")
    },
    removeCelebration() {
      this.selectedCelebration = ""
      this.disableOption("Ask", false)
      this.disableOption("Feeling", false)
    },
    deSelectOption(opt, val = false) {
      this.optionList = this.optionList.map(o => {
        if (o.name === opt) {
          return { ...o, selected: val }
        } else {
          return o
        }
      })
    },
    disableOption(opt, val = true) {
      this.optionList = this.optionList.map(o => {
        if (o.name === opt) {
          return { ...o, disabled: val }
        } else {
          return o
        }
      })
    },
    removeFeeling() {
      this.selectedFeeling.name = ""
      this.deSelectOption("Feeling")
      this.disableOption("Ask", false)
    },
    removeQuestionTag() {
      this.isQuestion = false
      this.postType = "post"
      this.selectedCategory = ""
      this.disableOption("Feeling", false)
      this.deSelectOption("Ask")
    },
    getTextData(val, len) {
      this.postDescription = val
      this.postDescriptionLength = len
    },
    post() {
      if (this.posting) {
        return
      }
      this.posting = true
      let payload = {}
      switch (this.postType) {
        case "post":
          payload = {
            user_circle: this.currentCircle.id,
            user: this.authUser.user.id,
            day_type: this.selectedFeeling.name,
            celebration_type: this.selectedCelebration,
            receiver_user: this.message_reciever_id,
            post_attach: this.imagesArray.length ? this.imagesArray.map(i => ({ name: i.name, sensitive: i.sensitive, type: i.type })) : [],
            latlong: null,
            post_text: this.postDescription,
            post_title: "",
            post_time: new Date().toISOString(),
            tags: this.selectedTags,
            parsing_link: this.selectedLinkToParse,
          }
          if ((this.postDescriptionLength && payload.post_text.length) || payload.post_attach.length) {
            if (this.editing) {
              payload.is_edited = true
              payload.updated_at = new Date().toISOString()
              PostRepository.deletePost(this.oldPostId, payload)
                .then(res => {
                  this.$notification.success({ message: "Success", description: "Your post has been edited successfully" })
                  this.getPost(false, 1)
                  this.hide()
                })
                .catch(err => {
                  this.$notification.error({ message: "Error", description: "Your post was not edited" })
                  this.posting = false
                })
            } else {
              PostRepository.createPost(payload)
                .then(res => {
                  if (!this.authUser.user.first_post) {
                    this.showCongrats()
                    this.authUser.user.first_post = true
                  } else {
                    this.$notification.success({ message: "Success", description: "Your post was created successfully." })
                  }
                  this.getPost(false, 1)
                  this.hide()
                })
                .catch(err => {
                  this.posting = false
                  this.$notification.error({ message: "Error", description: "Your post was not created." })
                })
            }
          } else {
            this.posting = false
            this.$notification.error({ message: "Error", description: "Please add content to submit a post." })
          }
          break
        case "question":
          payload = {
            user_circle: this.currentCircle.id,
            category: this.selectedCategory === "all" ? "" : this.selectedCategory,
            question: "",
            question_description: this.postDescription,
            question_attach: this.imagesArray.length ? this.imagesArray.map(i => ({ name: i.name, sensitive: i.sensitive, type: i.type })) : [],
            question_location: "location",
            latlong: null,
            user: this.authUser.user.id,
            tags: this.selectedTags,
          }
          if ((this.postDescriptionLength && payload.question_description.length) || payload.question_attach.length) {
            if (this.editing) {
              PostRepository.deleteQuestion(this.oldPostId, payload)
                .then(res => {
                  this.$notification.success({ message: "Success", description: "Your question has been edited successfully." })
                  this.getPost(false, 1)
                  this.hide()
                })
                .catch(err => {
                  this.$notification.error({ message: "Error", description: "Your question was not edited" })
                  this.posting = false
                })
            } else {
              PostRepository.createQuestion(payload)
                .then(res => {
                  this.$notification.success({ message: "Success", description: "Your question was created successfully." })
                  if (!this.authUser.user.first_post) {
                    this.showCongrats()
                    this.authUser.user.first_post = true
                  }
                  this.getPost(false, 1)
                  this.hide()
                })
                .catch(err => {
                  this.$notification.error({ message: "Error", description: "Your question was not created." })
                  this.posting = false
                })
            }
          } else {
            this.$notification.error({ message: "Error", description: "Please add content to submit a question." })
            this.posting = false
          }
          break
        case "poll":
          payload = {
            user: this.authUser.user.id,
            user_role: this.authUser.user.role,
            circle_id: this.currentCircle.id,
            type: "poll",
            poll_question: this.displayData.title || "",
            poll_description: "",
            post_text: this.postDescription,
            poll_duration: this.displayData.pollDuration,
            poll_attach: this.displayData.img.length ? [{ name: this.displayData.img[0].name, sensitive: false }] : [],
            choices: this.displayData.choices,
            tags: this.selectedTags,
          }
          PostRepository.createPoll(payload)
            .then(res => {
              this.$notification.success({ message: "Success", description: "Your poll was created successfully." })
              if (!this.authUser.user.first_post) {
                this.showCongrats()
                this.authUser.user.first_post = true
              }
              this.getPost(false, 1)
              this.hide()
            })
            .catch(err => {
              this.$notification.error({ message: "Error", description: "Your poll was not created." })
              this.posting = false
            })
          break
        case "job":
          payload = {
            user: this.authUser.user.id,
            user_role: this.authUser.user.role,
            type: "job",
            user_circle: this.currentCircle.id,
            job_attach: this.displayData.img.length ? [{ name: this.displayData.img[0].name, sensitive: false }] : [],
            job_title: this.displayData.jobTitle,
            location: { city: this.displayData.city, state: this.displayData.state },
            company_name: this.displayData.company,
            job_link: this.displayData.link,
            post_text: this.postDescription,
            job_type: this.displayData.jobType,
            job_description: this.displayData.des,
            workplace_type: this.displayData.workType,
            tags: this.selectedTags,
          }
          if (this.editing) {
            payload.is_edited = true
            payload.updated_at = new Date().toISOString()
            PostRepository.editJob(this.oldPostId, payload)
              .then(res => {
                this.$notification.success({ message: "Success", description: "Your job has been edited successfully." })
                this.getPost(false, 1)
                this.hide()
              })
              .catch(e => {
                this.$notification.error({ message: "Error", description: "Your job was not edited." })
                this.posting = false
              })
          } else {
            PostRepository.createJob(payload)
              .then(res => {
                this.$notification.success({ message: "Success", description: "Your job was created successfully." })
                if (!this.authUser.user.first_post) {
                  this.showCongrats()
                  this.authUser.user.first_post = true
                }
                this.getPost(false, 1)
                this.hide()
              })
              .catch(e => {
                this.$notification.error({ message: "Error", description: "Your job was not created." })
                this.posting = false
              })
          }
          break
        case "event":
          payload = {
            user: this.authUser.user.id,
            user_circle: this.currentCircle.id,
            user_role: this.authUser.user.role,
            tags: this.selectedTags,
            type: "event",
            post_text: this.postDescription,
            event_name: this.displayData.eventName,
            company_name: this.displayData.companyName,
            event_description: this.displayData.des,
            event_attach: this.displayData.img.length ? [{ name: this.displayData.img[0].name, sensitive: false }] : [],
            event_link: this.displayData.link,
            event_type: this.displayData.eventType,
            start_date: moment(this.displayData.startDate + this.displayData.startTime, "YYYY-MM-DDLT").format("YYYY-MM-DDTHH:mm:s"),
            end_date: this.displayData.endTime ? moment(this.displayData.endDate + this.displayData.endTime, "YYYY-MM-DDLT").format("YYYY-MM-DDTHH:mm:s") : null,
            time_zones: this.displayData.timeZone,
            speakers: this.displayData.speaker || [],
          }
          if (this.editing) {
            payload.is_edited = true
            payload.updated_at = new Date().toISOString()
            PostRepository.editEvent(this.oldPostId, payload)
              .then(res => {
                this.$notification.success({ message: "Success", description: "Your event has been edited successfully." })
                this.getPost(false, 1)
                this.hide()
              })
              .catch(e => {
                this.$notification.error({ message: "Error", description: "Your event was not edited." })
                this.posting = false
              })
          } else {
            PostRepository.createEvent(payload)
              .then(res => {
                this.$notification.success({ message: "Success", description: "Your event was created successfully." })
                if (!this.authUser.user.first_post) {
                  this.showCongrats()
                  this.authUser.user.first_post = true
                }
                this.getPost(false, 1)
                this.hide()
              })
              .catch(e => {
                this.$notification.error({ message: "Error", description: "Your event was not created." })
                this.posting = false
              })
          }
          break
        case "press":
        case "pressRelease":
          payload = {
            user: this.authUser.user.id,
            user_circle: this.currentCircle.id,
            user_role: this.authUser.user.role,
            type: "press",
            post_text: this.postDescription,
            tags: this.selectedTags,
            press_subject: this.displayData.subject || "",
            press_attach: this.displayData.img.length ? [{ name: this.displayData.img[0].name, sensitive: false }] : [],
            press_description: this.displayData.des || "",
            press_link: this.displayData.link || "",
          }
          if (this.editing) {
            payload.is_edited = true
            payload.updated_at = new Date().toISOString()
            PostRepository.editPressRelease(this.oldPostId, payload)
              .then(res => {
                this.$notification.success({ message: "Success", description: "Your press release has been edited successfully." })
                this.getPost(false, 1)
                this.hide()
              })
              .catch(e => {
                this.$notification.error({ message: "Error", description: "Your press release was not edited." })
                this.posting = false
              })
          } else {
            PostRepository.createPressRelease(payload)
              .then(res => {
                this.$notification.success({ message: "Success", description: "Your press release was created successfully." })
                if (!this.authUser.user.first_post) {
                  this.showCongrats()
                  this.authUser.user.first_post = true
                }
                this.getPost(false, 1)
                this.hide()
              })
              .catch(e => {
                this.$notification.error({ message: "Error", description: "Your press release was not created." })
                this.posting = false
              })
          }
          break
        default:
          this.posting = false
          console.warn("default POST")
      }
    },
    handleDeleteTag(val) {
      this.selectedTags = this.selectedTags.filter(t => t !== val)
      if (!this.selectedTags.length) {
        this.deSelectOption("Tags")
      }
    },
    show(action = "add", oldData, type = "post", tags = [], oldId) {
      this.showModal = true
      // this.postType = "post";
      // console.log("(show) oldData ->", oldData);
      this.currentDisplay = "add"
      // console.log("createnewpost show")
      if (action === "edit") {
        console.log("(show - edit) oldData ->", oldData)
        this.displayData = oldData
        this.postType = oldData.content_type || type
        this.editing = true
        this.selectedTags = oldData.tags && oldData.tags.length ? oldData.tags : tags
        this.oldPostId = oldData.id || oldId
        this.postDescription = oldData.post_text
        switch (oldData.content_type) {
          case "job":
            this.displayData = {
              img: oldData.job_attach_url || [],
              jobTitle: oldData.job_title,
              company: oldData.company_name,
              city: oldData.location.city,
              state: oldData.location.state,
              workType: oldData.workplace_type,
              des: oldData.job_description,
              link: oldData.job_link,
              jobType: oldData.job_type,
            }
            // console.log("displayData ->", this.displayData)
            this.disableOption("Feeling")
            this.disableOption("Image/video")
            this.disableOption("Ask")
            this.disableOption("More options")
            break
          case "press":
          case "pressRelease":
          case "pressrelease":
            this.displayData = {
              img: oldData.press_attach_url || [],
              subject: oldData.press_subject,
              des: oldData.press_description,
              link: oldData.press_link,
            }
            // console.log("displayData ->", this.displayData)
            this.disableOption("Feeling")
            this.disableOption("Ask")
            this.disableOption("Image/video")
            this.disableOption("More options")
            break
          case "event":
            this.displayData = {
              img: oldData.event_attach_url || [],
              eventName: oldData.event_name,
              eventType: oldData.event_type,
              startDate: oldData.start_date,
              endDate: oldData.end_date,
              timeZone: oldData.time_zones || "UTC-00:00",
              name: ["Speaker"],
              link: oldData.event_link,
              companyName: oldData.company_name,
              des: oldData.event_description,
              startDate: moment(oldData.start_date).format("YYYY-MM-DD"),
              startTime: ("0" + new Date(oldData.start_date).getUTCHours()).slice(-2) + ":" + ("0" + new Date(oldData.start_date).getUTCMinutes()).slice(-2),
              endDate: oldData.end_date && moment(oldData.end_date).format("YYYY-MM-DD"),
              endTime: oldData.end_date && ("0" + new Date(oldData.end_date).getUTCHours()).slice(-2) + ":" + ("0" + new Date(oldData.end_date).getUTCMinutes()).slice(-2),
            }
            // console.log("displayData ->", this.displayData)
            this.disableOption("Feeling")
            this.disableOption("Image/video")
            this.disableOption("Ask")
            this.disableOption("More options")
            break
          case "question":
            console.warn("QUESTION EDIT")
            this.isQuestion = true
            this.onlyQuestion = true
            this.postDescription = oldData.question_description || ""
            this.selectedCategory = oldData.category || "General"
            this.addingImages = oldData.question_attach_url ? oldData.question_attach_url.length : false
            this.imagesArray = oldData.question_attach_url || []
            this.disableOption("Feeling")
            this.deSelectOption("Ask", true)
            break
          default:
            // this.disableOption("Ask")
            // this.postType = "post"
            // this.oldPostId = oldData.id
            this.message_reciever_id = oldData.receiver_user ? oldData.receiver_user : null
            // this.postDescription = oldData.post_text
            this.selectedFeeling.name = oldData.day_type
            this.imagesArray = oldData.post_attach_url || []
            this.addingImages = oldData.post_attach_url ? oldData.post_attach_url.length : false
            // this.selectedTags = oldData.tags || []
            this.selectedCelebration = oldData.celebration_type
            if (this.selectedFeeling.name) {
              this.deSelectOption("Feeling", true)
            }
            this.disableOption("Ask")
        }
      } else if (action === "more") {
        // console.warn("(show) -- CLICKED MORE --")
        this.currentDisplay = "moreOptions"
        this.backScreen = "add"
        this.postType = "post"
        this.selectedTags = tags
        this.oldPostId = oldId
        this.disableOption("Ask", false)
        this.disableOption("Feeling", false)
        this.disableOption("Image/video", false)
      } else if (["job", "event", "press", "pressRelease"].includes(type)) {
        // console.warn("(show) -- inside job/press/event condition --")
        this.currentDisplay = "add"
        this.postType = type
        // console.log("postType ->", this.postType)
        this.displayData = oldData
        this.disableOption("Ask")
        this.disableOption("Feeling")
        this.disableOption("Image/video")
        // this.disableOption("More options")
      } else if (oldData) {
        console.warn("(show) -> ELSE IF CONDITION - olData is present")
        this.postType = type
        // console.log("data ->", oldData)
        this.displayData = oldData
        // this.currentDisplay = "add";
        this.changeScreen("add", type)
      } else if (["poll"].includes(type)) {
        // console.log("OPENING POLL")
        this.currentDisplay = "poll"
        this.addingImages = true
      } else if (["question"].includes(type)) {
        // console.log("OPENING QSTN")
        this.addingImages = false
        this.postType = "question"
        this.selectedCategory = this.questionType
        this.onlyQuestion = true
        this.isQuestion = true
        this.disableOption("Feeling")
        this.deSelectOption("Ask", true)
      } else {
        console.log("ELSE CONDITION")
        this.postType = "post"
      }
      if (this.selectedTags.length) {
        this.deSelectOption("Tags", true)
      }
    },
    hide() {
      this.isLinkParsed = false
      this.allLinksToParse = []
      this.selectedLinkToParse = ""
      this.editing = false
      this.postType = "post"
      this.isQuestion = false
      this.displayData = {}
      this.selectedCelebration = ""
      this.selectedCategory = ""
      this.postDescription = ""
      this.selectedTags.length = 0
      this.selectedFeeling = { name: "" }
      this.imagesArray = []
      this.addingImages = false
      this.optionList = [
        {
          name: "Image/video",
          disabled: false,
          selected: false,
          icon: "image",
          screen: "image",
          description: "Add Images",
        },
        {
          screen: "feelings",
          name: "Feeling",
          selected: false,
          disabled: false,
          icon: "comment-alt-smile",
          description: "Add Feeling",
        },
        {
          name: "Tags",
          selected: false,
          screen: "tags",
          disabled: false,
          icon: "tag",
          description: "Add Tags",
        },
        {
          name: "Ask",
          selected: false,
          screen: "question",
          disabled: false,
          icon: "question-circle",
          description: "Mark as Question",
        },
        {
          name: "More options",
          screen: "moreOptions",
          disabled: false,
          selected: false,
          icon: "ellipsis-v",
          description: "See more options",
        },
      ]
      setTimeout(() => {
        this.currentDisplay = "add"
        this.posting = false
      }, 100)
      this.showModal = false
    },
    changeScreen(screen = "add", type = "", val = "", prevScreen = "add") {
      // console.log("changed screen to ->", screen);

      if (screen === "back") {
        this.currentDisplay = this.backScreen
        return
      }
      this.backScreen = prevScreen

      // WHICH CONDITION ??
      if ((prevScreen = "moreOptions" && screen === "add" && ["press", "pressRelease", "job", "event"].includes(this.postType))) {
        console.warn("INSIDE IF CONDITION")
      }

      // after selecting qstn category - NOT REQD
      // coming back from more options
      // after selecting tags
      // after selecting feelings
      if (screen === "add" && !this.displayData.title && !this.isQuestion) {
        console.warn("-||--  I HAVE BEEN CALLED  --||-")

        console.log("prevScreen ->", prevScreen)
        console.log("screen ->", screen)

        console.log("backScreen ->", this.backScreen)
        console.log("currentDisplay ->", this.currentDisplay)
        console.log("postType ->", this.postType)
        console.log("displayData ->", this.displayData)
        // this.postType = "post"
        // this.addingImages = false
        // this.disableOption("Image/video", false)
        // this.disableOption("Feeling", false)
        // this.disableOption("Ask", false)

        if (this.postType === "post" && this.backScreen === "moreOptions") {
          this.removeTag()
        }
      }

      // CLICKING ON THE BOTTOM TAGS
      if (screen !== "image" && screen !== "question") {
        this.currentDisplay = screen // CHANGING SCREEN MAIN
      } else if (screen === "image") {
        this.currentDisplay = "add"
        this.addingImages = true
        // console.log("adding images -> true");
      } else if (screen === "question") {
        // if question is clicked
        this.postType = "question"
        // this.isQuestion = true;
        this.currentDisplay = "categorys"
      }

      if (screen === "poll") {
        this.addingImages = true
        // this.postType = 'poll';
      }

      if (this.imagesArray.length) {
        this.addingImages = true
      }

      //for job/event/press
      if (["job", "event", "press", "pressRelease"].includes(screen)) {
        this.showModal = false
        this.currentDisplay = "add"
        this.handleOtherModals(screen)
      }

      // CLICKING ON THE MORE OPTIONS OR VALUES IN OTHER SCREENS
      switch (type) {
        case "category":
          this.selectedCategory = val
          this.disableOption("Feeling")
          this.isQuestion = true
          this.postType = "question"
          console.log("case - category", val)
          break
        case "question":
          this.disableOption("Feeling")
          // this.isQuestion = true
          // this.postType = "question"
          console.log("case - question", val)
          break
        case "feeling":
          this.disableOption("Ask")
          this.selectedFeeling = val
          console.log("case - feeling", val)
          break
        case "tag":
          this.selectedTags = val
          console.log("case - tag", val)
          break
        case "celebration":
          this.disableOption("Ask")
          this.selectedCelebration = val
          this.disableOption("Feeling")
          console.log("case - celebration", val)
          break
        case "poll":
          this.postType = "poll"
          this.disableOption("Feeling")
          this.disableOption("Ask")
          // this.disableOption("More options")
          console.log("case - poll", val)
          break
        case "pressRelease":
          this.postType = "pressRelease"
          // this.disableOption("Ask");
          // this.disableOption("Feeling");
          console.log("case - press", val)
          // this.handleOtherModals("press")
          break
        case "event":
          this.postType = "event"
          // this.disableOption("Ask");
          // this.disableOption("Feeling");
          console.log("case - event", val)
          // this.handleOtherModals("event")
          break
        case "job":
          this.postType = "job"
          // this.disableOption("Ask");
          // this.disableOption("Feeling");
          console.log("case - job", val)
          // this.handleOtherModals("job")
          break
        default:
          console.log("Default changeScreen() case")
      }

      // SELECTING WHICHEVER IS CLICKED
      this.optionList = this.optionList.map(option => {
        // if (
        //   (type === "question" || screen === "question") &&
        //   option.name === "Ask"
        // ) {
        //   return {
        //     ...option,
        //     selected: this.isQuestion,
        //   };
        // }
        if (this.selectedCategory && option.name === "Ask") {
          this.isQuestion = true
          this.postType = "question"
          return {
            ...option,
            selected: true,
          }
        } else if ((type === "image" || screen === "image") && option.name === "Image/video") {
          return {
            ...option,
            selected: this.addingImages,
          }
        } else if ((type === "feeling" || screen === "feelings") && option.name === "Feeling") {
          // console.log("selectedFeeling ->", this.selectedFeeling.name)
          return {
            ...option,
            selected: this.selectedFeeling.name.length > 0 ? true : false,
          }
        } else if ((type === "celebration" || screen === "celebrations") && option.name === "Celebration") {
          // console.log("selectedCelebration ->", this.selectedCelebration)
          return {
            ...option,
            selected: this.selectedCelebration ? true : false,
          }
        } else if ((type === "tag" || screen === "tags") && option.name === "Tags") {
          return {
            ...option,
            selected: this.selectedTags.length > 0 ? true : false,
          }
        } else {
          return option
        }
      })
    },
    getDisplayData(data, type = "post") {
      this.postType = type // changing the component
      this.currentDisplay = "add" // changing the entire screen
      this.addingImages = false
      this.displayData = data
      switch (this.postType) {
        case "poll":
          this.disableOption("Feeling")
          this.disableOption("Ask")
          // this.disableOption("More options")
          this.disableOption("Image/video")
          break
      }
    },
    handleEditData(e) {
      console.log("edit ->", this.postType)
      switch (this.postType) {
        case "poll":
          this.currentDisplay = "poll"
          this.addingImages = true
          break
        case "job":
        case "press":
        case "pressRelease":
        case "event":
          this.showModal = false
          this.handleOtherModals(this.postType, this.displayData, this.postType, this.editing, this.selectedTags, this.oldPostId)
          break
      }
    },
    handleDeleteData(e) {
      console.log("delete ->", this.postType)
      switch (this.postType) {
        case "poll":
          this.addingImages = true
          this.currentDisplay = "poll"
          this.displayData = {
            choices: [],
            title: "",
            pollDuration: "Forever",
            img: [],
          }
          break
        case "job":
        case "press":
        case "pressRelease":
        case "event":
          this.showModal = false
          this.handleOtherModals(this.postType, null, this.postType, this.editing, [], this.oldPostId)
          break
      }
    },
  },
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
@media screen and (max-width: 600px) {
  .hide-in-mobile {
    display: none !important;
  }
  .font24 {
    font-size: 20px !important;
  }
  .my-4 {
    margin-bottom: 0px !important;
    margin-top: 16px !important;
  }
}
.ant-switch-checked {
  background: #e1eaf7 !important;
}
.ant-switch::after {
  transform: scale(1.5) !important;
  background: #cbd5e1 !important;
  width: 19px;
  height: 19px;
}
.ant-switch-checked::after {
  transform: translateX(-100%) scale(1.5) !important;
  background: #2a71d4 !important;
}
.dovedailySwitch {
  background: #e1eaf7 !important;
  transform: scale(0.7);
  min-width: 50px;
}
.saveBtn {
  width: fit-content;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/CreateNewPost.vue